// @unocss-include
import Layout from '@/components/layout/sider-menu-layout/index.vue';
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';

const route: SiteRouteItem = {
  path: '/production',
  component: Layout,
  name: PermissionPageKey.Production,
  meta: {
    title: 'production.title',
    icon: 'fluent-mdl2:product-variant',
    iconCls: 'bg-amber-500',
  },
  redirect: '/production/dashboard/material-dashboard', // 默认首页子路由
  children: [
    {
      path: 'dashboard',
      name: PermissionPageKey.ProductionDashboard,
      meta: {
        title: 'production.dashboard.title',
        icon: 'material-symbols:dashboard',
      },
      children: [
        {
          path: 'material-dashboard',
          name: PermissionPageKey.ProductionDashboardMaterial,
          component: () => import('../pages/dashboard/material-dashboard/index.vue'),
          meta: {
            title: 'production.dashboard.material_dashboard.title',
          },
        },
        {
          path: 'supplier-dashboard',
          name: PermissionPageKey.ProductionDashboardSupplier,
          component: () => import('../pages/dashboard/supplier-dashboard/index.vue'),
          meta: {
            title: 'production.dashboard.supplier_dashboard.title',
          },
        },
        {
          path: 'produce-dashboard',
          name: PermissionPageKey.ProductionDashboardProduce,
          component: () => import('../pages/dashboard/produce-dashboard/index.vue'),
          meta: {
            title: 'production.dashboard.procedure_dashboard.title',
          },
        },
      ],
    },
    {
      path: 'material',
      name: PermissionPageKey.ProductionMaterial,
      meta: {
        title: 'production.material.title',
        icon: 'devicon-plain:materializecss',
      },
      children: [
        {
          path: 'wms-receive-bill',
          name: PermissionPageKey.ProductionMaterialWmsReceiveBill,
          component: () => import('../pages/material/wms-receive-bill/index.vue'),
          meta: {
            title: 'production.material.wms_receive_bill.title',
          },
        },
        {
          path: 'receive-bill',
          name: PermissionPageKey.ProductionMaterialReceiveBill,
          component: () => import('../pages/material/receive-bill/index.vue'),
          meta: {
            title: 'production.material.receive_bill.title',
          },
        },
        {
          path: 'inspect-order/list/:tab?',
          name: PermissionPageKey.ProductionMaterialInspectOrderList,
          component: () => import('../pages/material/inspect-order-list/index.vue'),
          meta: {
            title: 'production.material.inspect_order_list.title',
            collapseMenuSiderOnMounted: true,
          },
        },
        {
          path: 'inspect-order/detail/:billNo',
          name: PermissionPageKey.ProductionMaterialInspectOrderDetail,
          component: () => import('../pages/material/inspect-order-detail/index.vue'),
          meta: {
            title: 'production.material.inspect_order_detail.title',
            hideInMenu: true,
            collapseMenuSiderOnMounted: true,
          },
        },
        {
          path: 'issue',
          name: PermissionPageKey.ProductionMaterialBug,
          component: () => import('../pages/material/issue/index.vue'),
          meta: {
            title: 'production.material.issue.title',
          },
        },
        {
          path: 'inspect-scheme/:tab?',
          name: PermissionPageKey.ProductionMaterialInspectScheme,
          component: () => import('../pages/material/inspect-scheme/index.vue'),
          meta: {
            title: 'production.material.inspect_scheme.title',
          },
        },
        {
          path: 'inspect-scheme/ai',
          name: PermissionPageKey.ProductionMaterialInspectSchemeViewer,
          component: () => import('../pages/material/inspect-scheme-viewer/index.vue'),
          meta: {
            title: 'production.material.inspect_scheme.ai.title',
            hideInMenu: true,
          },
        },
        {
          path: 'samples',
          name: PermissionPageKey.ProductionMaterialSamples,
          component: () => import('../pages/material/samples/index.vue'),
          meta: {
            title: 'production.material.samples.title',
          },
        },
      ],
    },
    {
      path: 'ort-test',
      name: PermissionPageKey.ProductionORTTest,
      component: () => import('../pages/ort-test/submit-test.vue'),
      meta: {
        title: 'ORT测试',
        hideInSoftwareProject: true,
        icon: 'material-symbols:settings-input-component-rounded',
      },
    },
    {
      path: 'ort-test-detail/:id',
      name: PermissionPageKey.ProductionORTTestReport,
      component: () => import('../pages/ort-test/test-report.vue'),
      meta: {
        title: 'ORT测报告',
        hideInMenu: true,
        hideInSoftwareProject: true,
      },
    },
    {
      path: 'supplier',
      name: PermissionPageKey.ProductionSupplier,
      meta: { title: '供应商', icon: 'material-symbols:manufacturing' },
      children: [
        {
          path: 'check-old',
          name: PermissionPageKey.ProductionSupplierCheck,
          component: () => import('../pages/supplier/supplier-check-old/index.vue'),
          meta: { title: '供应商审核(旧)', keepAlive: true },
        },
        {
          path: 'check',
          name: PermissionPageKey.ProductionSupplierAudit,
          component: () => import('../pages/supplier/supplier-check/index.vue'),
          meta: { title: '供应商审核', keepAlive: true },
        },
        {
          path: 'check/:id',
          name: PermissionPageKey.ProductionSupplierCheckDetail,
          component: () => import('../pages/supplier/supplier-check-detail/index.vue'),
          meta: { title: '供应商审核详情', hideInMenu: true },
        },
        {
          path: 'track',
          name: PermissionPageKey.ProductionSupplierTrack,
          component: () => import('../pages/supplier/supplier-track/index.vue'),
          meta: { title: '供应商跟踪' },
        },
        {
          path: 'evaluate',
          name: PermissionPageKey.ProductionSupplierEvaluate,
          component: () => import('../pages/supplier/supplier-evaluate/index.vue'),
          meta: { title: '供应商绩效' },
        },
        {
          path: 'supplier-list',
          name: PermissionPageKey.ProductionSettingSupplier,
          component: () => import('../pages/supplier/supplier-list/index.vue'),
          meta: { title: '供应商列表' },
        },
        {
          path: 'stencil-config',
          name: PermissionPageKey.ProductionSupplierStencilConfig,
          component: () => import('../pages/setting/stencil-config/index.vue'),
          meta: { title: '供应商模版配置', roles: ['admin', 'sqe', 'pmo'] },
        },
      ],
    },
    {
      path: 'shipments',
      name: PermissionPageKey.ProductionShipments,
      meta: {
        title: 'production.shipments.title',
        icon: 'iconamoon:delivery-fill',
      },
      children: [
        {
          path: 'inspect-order',
          name: PermissionPageKey.ProductionShipmentsInspectOrder,
          component: () => import('../pages/shipments/inspect-order/index.vue'),
          meta: { title: 'production.shipments.inspect_order.title' },
        },
        {
          path: 'inspect-standard',
          name: PermissionPageKey.ProductionShipmentsInspectStandard,
          component: () => import('../pages/shipments/inspect-standard/InspectStandard.vue'),
          meta: { title: 'production.shipments.inspect_standard.title' },
        },
        {
          path: 'inspect-detail',
          name: PermissionPageKey.ProductionShipmentsInspectDetail,
          component: () => import('../pages/shipments/inspect-detail/index.vue'),
          meta: { title: 'production.shipments.inspect_detail.title' },
        },
        {
          path: 'wms-inspect-order',
          name: PermissionPageKey.ProductionShipmentsWmsInspectOrder,
          component: () => import('../pages/shipments/wms-inspect-order/index.vue'),
          meta: { title: 'production.shipments.wms_inspect_order.title' },
        },
        {
          path: 'wms-inspect-detail',
          name: PermissionPageKey.ProductionShipmentsWmsInspectDetail,
          component: () => import('../pages/shipments/wms-inspect-detail/index.vue'),
          meta: { title: 'production.shipments.wms_inspect_detail.title' },
        },
        // {
        //   path: 'review-order',
        //   name: PermissionPageKey.ProductionShipmentsReviewOrder,
        //   component: () => import('../pages/shipments/review-order/index.vue'),
        //   meta: { title: '出货评审单' },
        // },
      ],
    },
    {
      path: 'produce-issue',
      name: PermissionPageKey.ProduceIssue,
      component: () => import('../pages/produceIssue/index.vue'),
      meta: {
        title: 'production.produceIssue.title',
        icon: 'ri:bug-fill',
      },
    },
    {
      path: 'setting',
      name: PermissionPageKey.ProductionSetting,
      meta: { title: '设置', icon: 'ri:settings-3-fill' },
      children: [
        {
          path: 'bad-category',
          name: PermissionPageKey.ProductionSettingBadCategory,
          component: () => import('../pages/setting/bad-category-config.vue'),
          meta: { title: '不良分类' },
        },
        {
          path: 'bad-measures',
          name: PermissionPageKey.ProductionSettingMeasures,
          component: () => import('../pages/setting/bad-measure-config.vue'),
          meta: { title: '不良对策' },
        },
        {
          path: 'bad-attribution',
          name: PermissionPageKey.ProductionSettingAttribution,
          component: () => import('../pages/setting/bad-attribution-config.vue'),
          meta: { title: '异常归属' },
        },
        {
          path: 'iqc-assign-logic',
          name: PermissionPageKey.ProductionSettingIqcAssignLogic,
          component: () => import('../pages/setting/iqc-assign-logic-config.vue'),
          meta: { title: 'IQC分配逻辑' },
        },
        {
          path: 'focus-projects',
          name: PermissionPageKey.ProductionSettingFocusProjects,
          component: () => import('../pages/setting/focus-projects/index.vue'),
          meta: { title: '关注项目' },
        },
        {
          path: 'material-ng-target',
          name: PermissionPageKey.ProductionSettingMaterialNgTarget,
          component: () => import('../pages/setting/material-ng-target-config.vue'),
          meta: { title: '不良率目标' },
        },
      ],
    },
  ],
};

export default route;
